import { TTypeAccess } from '@/services';

import { formatDate } from './date.util';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Whole days between now and end-of-day of the given ISO date. `null`
 * when the input is missing or unparseable.
 */
export const daysUntilDate = (iso?: string): number | null => {
	if (!iso) return null;
	const end = new Date(iso.slice(0, 10) + 'T23:59:59');
	if (Number.isNaN(end.getTime())) return null;
	return Math.ceil((end.getTime() - Date.now()) / MS_PER_DAY);
};

export type TTabletActivationBanner = {
	kind: 'office' | 'active' | 'expiring' | 'hidden';
	text: string;
};

/**
 * Decide the secondary line shown under the tablet name on TAB-03's
 * banner. See TAB-03 spec §3 — office IP wins, ≤1 day becomes a red
 * "오늘 만료" warning, otherwise show the date range.
 */
export const buildTabletActivationBanner = (
	typeAccess: TTypeAccess | undefined,
	validFrom: string | undefined,
	validUntil: string | undefined
): TTabletActivationBanner => {
	if (typeAccess === 'OFFICE') {
		return { kind: 'office', text: '사무실 접속' };
	}
	if (!validFrom || !validUntil) {
		return { kind: 'hidden', text: '' };
	}
	const remaining = daysUntilDate(validUntil);
	if (remaining !== null && remaining <= 1) {
		return { kind: 'expiring', text: '오늘 만료' };
	}
	return {
		kind: 'active',
		text: `활성화 기간: ${formatDate(validFrom)} ~ ${formatDate(validUntil)}`,
	};
};
